import type { Module } from 'vuex';
import { ICategory } from '../../entities/category-entity';
import {IMenuTreeItem} from "../../entities/menu-entity";
import {Category} from "sitisjs/dist/internal/sections/categories/models/Category";
import {IGetCategoryDetailedParams} from "../../../lib/store/modules/catalog-store";

export const namespace = 'brands';

export const MutationType = {
	SET_BRANDS: 'SET_BRANDS',
	SET_BRAND: 'SET_BRAND',
	SET_CATEGORY_DETAILED: 'setCategoryDetailed',
};
export const actionType = {
	GET_BRANDS: 'GET_BRANDS',
	GET_CATEGORY_DETAILED: 'GET_CATEGORY_DETAILED',
};



export default function brandsStore(): Module<any, any> {
	return {
		namespaced: true,
		state: () => ({
			brand: null,
			brands: [],
		}),
		actions: {
			async [actionType.GET_BRANDS]({ commit }): Promise<any> {
				try {
					commit('appState/setLoading', { brands: true }, { root: true });
					const res = await this.$api.brand.getBrands.execute({
						page: 1
					});
					const catalog = res.getValue();
					const brands = catalog?.brands || [];
					commit(MutationType.SET_BRANDS, brands);
					return brands;
				} finally {
					commit('appState/setLoading', { brands: false }, { root: true });
				}
			},
			async [actionType.GET_CATEGORY_DETAILED]({ commit, state, dispatch }, params: IGetCategoryDetailedParams): Promise<ICategory | undefined> {
				const {
					slug,
					extensions
				} = params;

				let filters = [];
				if ((extensions || []).length > 0) {
					filters.push(`expand=${extensions?.join(',')}`)
				}

				try {
					commit('appState/setLoading', { category: true }, { root: true });

					const filterString = Boolean(filters.length > 0) ? `?${filters.join("&")}` : "";
					const response = await this.$api.agent.transport.get(`/brands/${ slug }${ filterString }`).then((res: any) => {
						return res.data
					}).catch(() => {
						return undefined
					})
					if (!response) {
						return undefined
					}

					const category = new Category(response);

					commit(MutationType.SET_CATEGORY_DETAILED, category || null);

					return category;
				} finally {
					// commit('appState/setLoading', { category: false }, { root: true });
				}
			},
		},
		mutations: {
			[MutationType.SET_BRANDS]: (state, brands: any[]) => {
				state.brands = brands;
			},
			[MutationType.SET_BRAND]: (state, brand: any[]) => {
				state.brand = brand;
			},
			[MutationType.SET_CATEGORY_DETAILED]: (state, category: ICategory) => {
				state.brand = category;
			},
		},
		getters: {
			brand: ({ brand }) => brand,
			brands: ({ brands }): ICategory[] => brands
		},
	};
}
